const conditionalWrapper = ({
  condition,
  wrapper,
  children,
  elseDisplayChildren
}) => (condition ? wrapper(children) : elseDisplayChildren ? children : null);

export default conditionalWrapper;

